import {
  Col,
  Flex,
  Form,
  Row,
  Typography,
  Input,
  Space,
  Spin
} from "antd";
import { FormInstance } from "antd/es/form/hooks/useForm";
import { useTranslation } from "react-i18next";
import classes from "./invoiceDataForm.module.css";
// import { PREFIXES } from "../../constants/app";
import { CodeFiscaleInput, PhoneNumberInput, RegionInput } from "../Form";
import useInvoiceDataForm from "./useInvoiceDataForm";

const { Title, Text } = Typography;

type InvoiceDataFormProps = { form: FormInstance, handleSubmit: (values: any) => void };

const InvoiceDataForm = ({ form, handleSubmit } : InvoiceDataFormProps) => {
  const { t } = useTranslation();
  const { loading } = useInvoiceDataForm({ form });

  return (
    <Flex vertical>
      <Spin fullscreen spinning={loading} />
      <Space direction="vertical" size={8} style={{ marginBottom: 24 }}>
        <Title level={3} style={{ marginBottom: 0 }}>{t("invoiceDataForm.title")}</Title>
        <Text type="secondary" style={{ fontSize: 18 }}>{t("invoiceDataForm.subtitle")}</Text>
      </Space>
      <Row gutter={24}>
        <Col span={24} sm={12}>
          <Form
            layout="vertical"
            form={form}
            requiredMark={false}
            onFinish={handleSubmit}
            className={classes.form}
            size="large"
          >
            <Form.Item
              name="invoiceName"
              label={t("form.label.name")}
              rules={[{ required: true, message: t("form.error.name") }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="invoiceSurname"
              label={t("form.label.surname")}
              rules={[{ required: true, message: t("form.error.surname") }]}
            >
              <Input />
            </Form.Item>
            <CodeFiscaleInput name="invoiceCodFisc" label="Codice Fiscale" />
            <Form.Item
              name="address"
              label={t("form.label.address")}
              rules={[{ required: true, message: t("form.error.address") }]}
            >
              <Input />
            </Form.Item>
          </Form>
        </Col>
        <Col span={24} sm={12}>
          <Form
            layout="vertical"
            form={form}
            requiredMark={false}
            onFinish={handleSubmit}
            className={classes.form}
            size="large"
          >
            <Form.Item
              name="cap"
              label={t("form.label.cap")}
              rules={[{ required: true, message: t("form.error.cap") }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="city"
              label={t("form.label.city")}
              rules={[{ required: true, message: t("form.error.city") }]}
            >
              <Input />
            </Form.Item>
            <RegionInput
              name="province"
              label={t("form.label.province")}
              rules={[{ required: true, message: t("form.error.province") }]}
            />
            <PhoneNumberInput
              name="phone"
              label={t("form.label.phone")}
              rules={[{ required: true, message: t("form.error.phone") }]}
            />
          </Form>
        </Col>
      </Row>
    </Flex>
  );
};

export default InvoiceDataForm;
